module.exports = __webpack_public_path__ + "img/er.54bcf14e.svg";